import $ from "jquery"

$(function () {
    const $header = $('.header');

    if (!$header.length) {
        return;
    }

    const updateHeaderFixed = () => {
        const scrollTop = $(window).scrollTop();

        if (scrollTop > 0) {
            if (!$header.hasClass('is-fixed')) {
                const headerHeight = $header.outerHeight();
                $header.addClass('is-fixed');
                $('body').css('padding-top', headerHeight);
            }
        } else {
            $header.removeClass('is-fixed');
            $('body').css('padding-top', '');
        }
    };

    const updateBodyPadding = () => {
        if ($header.hasClass('is-fixed')) {
            $('body').css('padding-top', $header.outerHeight());
        }
    };

    $(window).on('scroll', updateHeaderFixed);
    $(window).on('resize', updateBodyPadding);

    updateHeaderFixed();

    const $inner = $('.js-header-inner');
    const $toggler = $('.js-header-toggler');
    const $overlay = $('.js-header-overlay');
    const desktopNavQuery = window.matchMedia('(min-width: 1200px)');

    const setMenuOpen = (open) => {
        $inner.toggleClass('is-shown', open);
        $overlay.prop('hidden', !open);
        $toggler.attr('aria-expanded', open ? 'true' : 'false');
        $('html, body').toggleClass('is-header-menu-open', open);
        updateBodyPadding();
    };

    $toggler.on('click', function () {
        setMenuOpen(!$inner.hasClass('is-shown'));
    });

    $overlay.on('click', function () {
        setMenuOpen(false);
    });

    $(document).on('keydown', function (event) {
        if (event.key === 'Escape' && $inner.hasClass('is-shown')) {
            setMenuOpen(false);
        }
    });

    $(window).on('resize', function () {
        if (desktopNavQuery.matches) {
            setMenuOpen(false);
        }
    });
});
